/* eslint-disable no-console */
import {ArrowRightOutlined} from '@ant-design/icons';
import {Button, Form} from 'antd';
import React, {useEffect, useState} from 'react';

import Loader from '../../../../../components/Loader/Loader';
import OPCategory from '../../../../../services/modules/JSON/categoryOP';
import OPSubCategory from '../../../../../services/modules/JSON/subCategory';
import typeOfBusiness from '../../../../../services/modules/JSON/typeOfBusiness';
import companyDetails from '../../../../../services/modules/OM/companyDetails';
import useCompanyStore from '../../../../../store/companyStore/companyDetailsStore';
import {hasUserRole, UserRole} from '../../../../../utils/commonFunctions';
import showMessage from '../../../../../utils/showMessage';
import {OPKey} from '../constants/orgProfileKeyLabel';

import {filterCompanyDetails} from './commonFunctions';
import GeneralDisclosureForm from './GeneralDisclosureForm';

const GeneralDisclosure: React.FC<{
  setActiveKey?: React.Dispatch<React.SetStateAction<string>>;
  nextTabId?: string;
}> = ({setActiveKey, nextTabId}) => {
  const [isLoading, setIsLoading] = useState(true);
  const companyData = useCompanyStore((state) => state.companyDetails);
  const [isChanged, setIsChanged] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    Promise.all([
      OPCategory(),
      OPSubCategory(),
      typeOfBusiness(),
      companyDetails()
    ])
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {});
  }, []);

  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    const {businessEmail, ...restValues} = values;
    companyData[OPKey.PERSONAL_EMAIL] = businessEmail;
    const data = filterCompanyDetails({...companyData, ...restValues});

    setIsSubmitted(true);
    Promise.all([
      companyDetails(
        {
          ...data
        },
        true
      )
    ])
      .then((res) => {
        res.map((item: any) => {
          return showMessage(item);
        });
        if (setActiveKey && nextTabId) {
          setActiveKey(nextTabId);
        }
      })
      .catch(() => {})
      .finally(() => {
        setIsSubmitted(false);
        setIsChanged(false);
      });
  };

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      style={{overflow: 'hidden'}}
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={companyData}
      disabled={hasUserRole(UserRole.View_Only)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
      scrollToFirstError
      onValuesChange={() => {
        setIsChanged(true);
      }}
      onFinishFailed={() => {
        setIsSubmitted(false);
      }}
      autoComplete="off"
    >
      <GeneralDisclosureForm />
      <Button
        type="primary"
        htmlType="submit"
        style={{marginTop: '20px', float: 'right'}}
        disabled={!isChanged}
        loading={isSubmitted}
      >
        Save & Next <ArrowRightOutlined />
      </Button>
    </Form>
  );
};

export default GeneralDisclosure;
